import { EmbeddedBOQCoatProduct } from '../interfaces';

export const isSpreadRateCustom = (cp: EmbeddedBOQCoatProduct)  => {
	const method = findMethod(cp);
	if (method) {
		const defSpreadRate = method.spreadRate;
		return typeof cp.spreadRate === 'number'
			&& typeof defSpreadRate === 'number'
			&& !equal(cp.spreadRate, defSpreadRate);
	}

}

export const isApplicationRateCustom = (cp: EmbeddedBOQCoatProduct, boqHeightRange?: string) => {
	const method = findMethod(cp);
	if (method) {
		let defApplicationRate = method.applicationTargetRate;

		if (boqHeightRange) {
			for (let heightRangeRate of method.heightRangeRates) {
				if (heightRangeRate.title === boqHeightRange) {
					defApplicationRate = heightRangeRate.value;
				}
			}
		}

		return typeof cp.targetRate === 'number'
			&& typeof defApplicationRate === 'number'
			&& !equal(cp.targetRate, defApplicationRate);
	}
}

const findMethod = (cp: EmbeddedBOQCoatProduct) => {
	const methods = cp?.product?.applicationMethods ?? [];
	const wanted = (cp.applicationMethod ?? '').trim().toLowerCase();
	return methods.find(m => (m.type ?? '').trim().toLowerCase() === wanted);
}

export const defaultSpread = (cp: EmbeddedBOQCoatProduct) => {
	return findMethod(cp)?.spreadRate;
}

export const defaultApp = (cp: EmbeddedBOQCoatProduct, boqHeightRange?: string) => {
	const method = findMethod(cp);
	if (boqHeightRange) {
		for (let heightRangeRate of method.heightRangeRates) {
			if (heightRangeRate.title === boqHeightRange) {
				return heightRangeRate.value;
			}
		}
	}

	return method?.applicationTargetRate;
}

const equal = (a: number, b: number, eps = 1e-6) => {
	return Math.abs(a - b) <= eps;
}